import React, { useState } from 'react'
import './style.scss'

const CoordConverButton = ({callback,buttonState}) => {
    const [changeState,setChangeState] = useState(buttonState)
  return (
    <button id="coordinateButton" title='Coordinate conversion' onClick={(e)=>{
    callback()
    setChangeState(prevState=>!prevState)
    }
    }>
        {changeState?<span style={{fontSize:'20px'}}>&#8676;</span>:<span>XY</span>}
    </button>
  )
}


export default CoordConverButton